import { NavigateFunction } from 'react-router-dom';

// Components
import Empty from '../../Common/List/Empty';
import ShowMore from '../../Common/List/ShowMore';
import NewsPreview from './Preview';

// Enums
import { ListLimit } from '../../../enums/Deals';

// Interfaces
import { NewsInterface } from '../../../interfaces/News';

// Styles
import './index.scss';

// Utils
import JSUtil from '../../../utils/JSUtil';

interface PropsInterface {
  news: NewsInterface[],
  amount: number,
  limit: number,
  setLimit: (arg0: number) => void;
  navigate: NavigateFunction,
}

const NewsList = (props: PropsInterface) => {
  return (
    <div className="news-wrapper">
      {
        !JSUtil.isEmpty(props.news)
        ?
        <>
          {
            props.news.map((news, index) => 
              <NewsPreview 
                key={index}
                news={news}
                navigate={props.navigate} 
              />
            )
          }
          <div className='clear-float'/>
          <ShowMore
            limit={props.limit}
            setLimit={props.setLimit}
            plusLimit={ListLimit}
            amount={props.amount}
          />
        </>
        : <Empty />
      }

    </div>
  );
}

export default NewsList;